import { openInBlobInBlank } from "../../../../../common/utils/view_utils";
import { IGenerateCertificateUseCase } from "../../../presentation/useCases/read/generate_certificate_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GenerateCertificateUseCase
 */

export class GenerateCertificateUseCase implements IGenerateCertificateUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async generateCertificate(
    idFuncionarioTreinamento: number,
  ): Promise<void> {
    const results = await this.repository.generateCertificate(idFuncionarioTreinamento);
    await openInBlobInBlank("Certificado.pdf", results);
  }
}
